import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Command } from "@air/cmdk";
import * as RadixPopover from "@radix-ui/react-popover";
import { memo, useCallback, useState } from "react";
import { SearchCommandBoardList } from "~/components/SearchCommand/SearchCommandBoardList";
import { SearchCommandClearButton } from "~/components/SearchCommand/SearchCommandClearButton";
import { SearchCommandInput } from "~/components/SearchCommand/SearchCommandInput";
import { SearchCommandSavedFilterList } from "~/components/SearchCommand/SearchCommandSavedFilterList";
import { SearchCommandSuggestionList } from "~/components/SearchCommand/SearchCommandSuggestionList";
import { SearchCommandTrigger } from "~/components/SearchCommand/SearchCommandTrigger";
export const MobileSearchCommand = /*#__PURE__*/ memo((param)=>{
    let { defaultOpen, filtersCount, onBoardClick: _onBoardClick, onClear, onOpenChange, onSavedFilterSelect: _onSavedFilterSelect, onSearchChange, onSuggestionClick: _onSuggestionClick, placeholder, search, suggestions } = param;
    const [isOpen, setIsOpen] = useState(defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false);
    const [searchValue, setSearchValue] = useState(search);
    const onOpen = useCallback(()=>{
        setIsOpen(true);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(true);
    }, [
        onOpenChange
    ]);
    const onBoardClick = useCallback((board)=>{
        setIsOpen(false);
        _onBoardClick === null || _onBoardClick === void 0 ? void 0 : _onBoardClick(board);
    }, [
        _onBoardClick
    ]);
    const onSavedFilterSelect = useCallback((savedFilter)=>{
        setIsOpen(false);
        _onSavedFilterSelect === null || _onSavedFilterSelect === void 0 ? void 0 : _onSavedFilterSelect(savedFilter);
    }, [
        _onSavedFilterSelect
    ]);
    const onSuggestionClick = useCallback((suggestion)=>{
        setIsOpen(false);
        setSearchValue(suggestion);
        _onSuggestionClick === null || _onSuggestionClick === void 0 ? void 0 : _onSuggestionClick(suggestion);
    }, [
        _onSuggestionClick
    ]);
    const onValueChange = useCallback((value)=>{
        setSearchValue(value);
        onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange(value);
    }, [
        onSearchChange
    ]);
    return /*#__PURE__*/ _jsx(Command, {
        className: "w-full",
        "data-testid": "SEARCH_COMMAND",
        shouldFilter: false,
        defaultSearch: search,
        children: /*#__PURE__*/ _jsxs(RadixPopover.Root, {
            open: isOpen,
            onOpenChange: setIsOpen,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ _jsx(RadixPopover.Trigger, {
                            asChild: true,
                            children: /*#__PURE__*/ _jsx(SearchCommandTrigger, {
                                count: filtersCount,
                                "data-testid": "SEARCH_COMMAND_TRIGGER",
                                onClick: onOpen,
                                placeholder: placeholder
                            })
                        }),
                        !!onClear && /*#__PURE__*/ _jsx(SearchCommandClearButton, {
                            onClick: onClear
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(RadixPopover.Portal, {
                    children: /*#__PURE__*/ _jsxs(RadixPopover.Content, {
                        className: "pointer-events-none relative left-0 top-[calc(var(--radix-popover-trigger-height)*-1)] flex h-[calc(var(--radix-popover-content-available-height)+var(--radix-popover-trigger-height))] w-screen flex-col overflow-hidden transition-all data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=open]:fade-in",
                        "data-testid": "SEARCH_COMMAND_CONTENT",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex flex-col border-b border-b-grey-5 px-4 pb-2",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "relative w-[var(--radix-popover-trigger-width)]",
                                    children: [
                                        /*#__PURE__*/ _jsx(SearchCommandInput, {
                                            defaultValue: searchValue,
                                            className: "m-0 rounded-4 border border-grey-5",
                                            count: filtersCount,
                                            onValueChange: onValueChange,
                                            placeholder: placeholder,
                                            value: searchValue
                                        }),
                                        !!onClear && /*#__PURE__*/ _jsx(SearchCommandClearButton, {
                                            onClick: onClear
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "pointer-events-auto grow overflow-y-auto bg-grey-2",
                                children: isOpen && /*#__PURE__*/ _jsxs(Command.List, {
                                    className: "flex flex-col gap-3 px-4 py-3",
                                    "data-testid": "SEARCH_COMMAND_LIST",
                                    children: [
                                        !!onSuggestionClick && /*#__PURE__*/ _jsx(SearchCommandSuggestionList, {
                                            onSelect: onSuggestionClick,
                                            suggestions: suggestions === null || suggestions === void 0 ? void 0 : suggestions.suggestions
                                        }),
                                        !!(suggestions === null || suggestions === void 0 ? void 0 : suggestions.savedFilters.length) && !!onSavedFilterSelect && /*#__PURE__*/ _jsx(SearchCommandSavedFilterList, {
                                            onSelect: onSavedFilterSelect,
                                            savedFilters: suggestions.savedFilters
                                        }),
                                        !!(suggestions === null || suggestions === void 0 ? void 0 : suggestions.boards.length) && /*#__PURE__*/ _jsx(SearchCommandBoardList, {
                                            boards: suggestions.boards,
                                            onBoardClick: onBoardClick
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
});
MobileSearchCommand.displayName = "MobileSearchCommand";
